import { Injectable } from '@angular/core';
import { ServiceConfig } from 'app/_services/service-config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SentimentReportsService {
    private host = ServiceConfig.host;
    private BASE_URL = this.host + '/api/brand-manage';
    private url_report = this.host + '/api/ipcc/';
    private url_report_manage = this.host + '/api/report-manager/';
    private httpHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    private httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')).token);

    constructor(private httpClient: HttpClient) {
    }

    getAll(): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/getActive`, {}, { params: this.httpParams, headers: this.httpHeaders });
    }

    getReport(body): Observable<any> {
        return this.httpClient.post(`${this.url_report}/report/brandReportChart`, body, { params: this.httpParams, headers: this.httpHeaders });
    }

    getSuggestionPost(body): Observable<any> {
        return this.httpClient.post(`${this.url_report}/report/getRecentPost`, body, { params: this.httpParams, headers: this.httpHeaders });
    }

    createReportManager(config): Observable<any> {
        let data = JSON.parse(localStorage.getItem('currentSmmData'));
        let url = this.url_report_manage + 'create?token=' + data.token;
        return this.httpClient.post<any>(url, config);
    }

    getAllReportManager(body): Observable<any> {
        return this.httpClient.post(`${this.url_report_manage}/getList`, body, { params: this.httpParams, headers: this.httpHeaders });
    }

    deleteReport(id): Observable<any> {
        return this.httpClient.get(this.url_report_manage + `/delete/${id}`, { params: this.httpParams, headers: this.httpHeaders });
    }

    updateReport(id, dataUpdate): Observable<any> {
        return this.httpClient.post(this.url_report_manage + `/update/${id}`, dataUpdate, { params: this.httpParams, headers: this.httpHeaders });
    }

}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/sentiment-report/sentiment-reports.service.ts